import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import gsap from "gsap";
import "./style.scss";

const PrizeSlotsCounter = ({ toAmount=1, showDecimal=true, showCurrency=true, currency="US", spiningDuration=1, minNumbers=1 }) => {
    const [digits, setDigits] = useState([]);
    const tl = useRef(null);

    useEffect(() => {
        // Initialize GSAP timeline
        tl.current = gsap.timeline();

        // Animate the amount
        tl.current.to({}, {
            duration: spiningDuration,
            ease: 'power2.out',
            onUpdate: () => {
                let currentAmount = formatNumber(tl.current.progress() * toAmount);
                if(!showDecimal)
                    currentAmount = currentAmount.split('.')[0];
                setDigits(currentAmount.split(''));
            },
        });

        // Cleanup on component unmount
        return () => tl.current.kill();
    }, [toAmount, spiningDuration]);

    const formatNumber = (number) => {
        return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&');
    };

    return (
        <div className={"PrizeSlotsCounter"} >
            {showCurrency && currency === "US" && <span className={"gold-gradient-text"}>$</span>}
            {digits.map((digit, index) => (
                <span key={index} className={"gold-gradient-text "+([",", "."].includes(digit)? "dec":"digitBox")}>{digit}</span>
            ))}
            {showCurrency && currency === "MXN" && <span className="gold-gradient-text">$</span>}
            {showCurrency && currency === "EURO" && <span className="gold-gradient-text">€</span>}
        </div>
    );
}
export default PrizeSlotsCounter;